/** The two fallback panels the page itself can raise, in the firm's own words. */

export const ROUTED_FALLBACK = {
  headline: "Let's talk this one through",
  body: "This needs a direct conversation rather than an automatic number. Leave your details and one of our team will come back to you with a tailored quote.",
  reasons: [],
};

export const GENERAL_FALLBACK = {
  headline: "Tell us about your situation",
  body: "If none of the three flows above fits what you need, that's absolutely fine — leave your details and we'll put together a custom quote for you.",
  reasons: [],
};
